// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_row__5SV5B {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    /*grid-gap: 20px;*/
    /*margin: 0 0 20px;*/
    /*padding: 14px 40px;*/
}

.styles_column__IxhcY {
    display: flex;
    grid-gap: 40px;
    /*flex: 1;*/
    /*max-width: 300px;*/
}

.styles_right__tR9fj {
    display: flex;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/SelectionPopup/SelectionPopupCountryRow/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB","sourcesContent":[".row {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    /*grid-gap: 20px;*/\n    /*margin: 0 0 20px;*/\n    /*padding: 14px 40px;*/\n}\n\n.column {\n    display: flex;\n    grid-gap: 40px;\n    /*flex: 1;*/\n    /*max-width: 300px;*/\n}\n\n.right {\n    display: flex;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `styles_row__5SV5B`,
	"column": `styles_column__IxhcY`,
	"right": `styles_right__tR9fj`
};
export default ___CSS_LOADER_EXPORT___;
